import { Model } from './model';

export class MenuEntries extends Model {
  entries: string[];
}

export const SMS_SENDERS = 'sms_senders';
